import { differenceInMinutes } from "date-fns";

import { BookingResponse } from "../../../api/hooks/useBookingById/type.ts";
import { BookingInfoFormScheme } from "../../../components/Forms/BookingInfoForm/validation.ts";
import { EquipmentFormScheme } from "../../../components/Forms/EquipmentForm/validation.ts";

// Durations are picked in half-hour steps, so whole-hour helpers like differenceInHours drop the
// half hour.
const durationInHours = (startDate: string, endDate: string) =>
  differenceInMinutes(new Date(endDate), new Date(startDate)) / 60;

export const mapBookingToInfoForm = (data: BookingResponse): BookingInfoFormScheme => ({
  name: data.clientDetails.name,
  date: new Date(data.hallDetails.startDate),
  slotDate: data.hallDetails.startDate,
  hoursNumber: durationInHours(data.hallDetails.startDate, data.hallDetails.endDate),
  lightSetup: data.defaultEquipment || "",
  hall: data.hallDetails.id,
  email: data.clientDetails.email,
  comment: data.clientDetails.comment,
  phone: data.clientDetails.phone.replace(/(\d{2})(\d{3})(\d{4})/, "$1 $2 $3"),
  sendBookingDetailsSms: false,
  smsText: "",
});

export const mapBookingToEquipmentForm = (data?: BookingResponse): EquipmentFormScheme => ({
  equipment:
    data?.equipmentsDetails.map((item) => ({
      count: item.bookedCount,
      range: durationInHours(item.startDate, item.endDate),
      id: item.id,
      imageUrl: item.imageUrl,
      title: item.title,
      pricePerUnit: item.pricePerUnit,
      isFixedPrice: item.isFixedPrice,
    })) || [],
});
